// @flow
import * as React from 'react'
import { Query, type ApolloResults } from 'react-apollo'
import type { School } from 'types'
import { IfAuthenticated, UnlessAuthenticated } from 'framework'
import { Button } from 'ui/Form'
import { H6, P } from 'ui/Typography'
import RelatedProgram from './RelatedProgram'
import LoginModal from 'ui/LoginModal'
import {
  RELATED_SCHOOL_LISTINGS_QUERY,
  type RelatedSchoolListingsData,
  type RelatedSchoolListingsVariables,
} from './query'

import './RelatedPrograms.scss'

type Props = {
  school: School,
}

type State = {
  showLogin: boolean,
}

const SEARCH_RADIUS = 10
const SEARCH_LIMIT = 4

export default class SchoolPageRelatedListings extends React.Component<Props, State> {
  state = {
    showLogin: false,
  }

  render = () => {
    const { school } = this.props
    if (!school.address) return null

    const { latitude, longitude } = school.address
    if (!latitude || !longitude) return null

    const variables: RelatedSchoolListingsVariables = {
      location: {
        byCenter: {
          coords: {
            latitude,
            longitude,
          },
          radius: SEARCH_RADIUS,
        },
      },
      excludeSchoolIds: [school.id],
      limit: SEARCH_LIMIT,
    }

    return (
      <Query query={RELATED_SCHOOL_LISTINGS_QUERY} variables={variables}>
        {this.renderContent}
      </Query>
    )
  }

  renderContent = (result: ApolloResults<RelatedSchoolListingsData>) => {
    const { data, loading, error } = result
    if (loading || error || !data.schoolListings) return null

    const { listings } = data.schoolListings
    if (!listings.length) return this.renderNoListings()

    return listings.map((listing, i) => <RelatedProgram key={i} listing={listing} />)
  }

  renderNoListings = () => {
    return (
      <React.Fragment>
        <UnlessAuthenticated>
          <P>
            We’re still expanding into this area. Want to be the first to know about great
            Wonderschools in this area?
          </P>
          <P>
            <H6>
              <Button appearance="link" onClick={() => this.setState({ showLogin: true })}>
                Notify Me
              </Button>
            </H6>
          </P>
        </UnlessAuthenticated>
        <IfAuthenticated>
          We’re still expanding into this area. We'll let you know when other great Wonderschools
          pop up here.
        </IfAuthenticated>
        {this.renderLoginMaybe()}
      </React.Fragment>
    )
  }

  renderLoginMaybe = () => {
    if (!this.state.showLogin) return null

    return (
      <LoginModal
        onLogin={this.handleRequestCloseLogin}
        onRequestClose={this.handleRequestCloseLogin}
      />
    )
  }

  handleRequestCloseLogin = () => {
    this.setState({ showLogin: false })
  }
}
